'use client';

import { StoryblokImage } from '@/components/customFields/StoryblokImage';
import Zitatzeichen from '@/public/icons/zitat_zeichen.svg';
import type { ComponentQuoteStoryblok } from '@/types/component-types-sb';
import { storyblokEditable } from '@storyblok/react/rsc';
import classNames from 'classnames';

import classes from './Quote.module.scss';

const Quote: React.FC<{ blok: ComponentQuoteStoryblok }> = ({ blok }) => {
  return (
    <blockquote className={classes.quote} {...storyblokEditable(blok)}>
      <div className={classNames(classes.quoteCard, { [classes.noImage!]: !blok.profilbild?.filename })}>
        <Zitatzeichen aria-hidden={true} className={classes.icon} />
        {blok.profilbild && (
          <StoryblokImage
            image={blok.profilbild}
            className={classes.image}
            key={blok.profilbild.id}
            aspectRatio={1}
            width={{ pxMobile: 40, pxTablet: 40, pxDesktop: 210 }}
            alt={blok.imageAltTag}
          />
        )}
        <div className={classes.zitat}>{blok.zitat}</div>
        <p className={classNames(classes.name, 'font-action-label-small')}>
          {blok.position?.length ? `${blok.name} • ${blok.position}` : blok.name}
        </p>
      </div>
    </blockquote>
  );
};

export default Quote;
